import { render } from "./AccountVerification.vue?vue&type=template&id=540ff5dc&ts=true"
import script from "./AccountVerification.vue?vue&type=script&lang=ts"
export * from "./AccountVerification.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__